// extracted by mini-css-extract-plugin
export default {"SectionTitle":"Education_SectionTitle__3ZBue","Cards":"Education_Cards__YXSgT"};